import {
  CreatorKind,
  TaskSource,
  TimeWindow,
} from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/enums.pb';
import {
  CountOfTasksReviewedByLocationResponse,
  TaskService,
} from '@weave/schema-gen-ts/dist/schemas/task-center/v1/task_service.pb';
import { authorizedFetch } from '../../../../../../../helpers/utils';
import {
  getTruelarkBusinessIdQueryOptions,
  getTenDlcRegistrationStatusQueryOptions,
  getBusinessSettingsQueryOptions,
  getAutoRulesQueryOptions,
  getSchedulingAppointmentTypesQueryOptions,
  getSchedulingStaffsQueryOptions,
  getSchedulingResourcesQueryOptions,
  getSchedulingSchedulesQueryOptions,
} from '../voice-air-handoff/voice-air-handoff.queries';

export const MessagingAirHandoffQueryKeys = {
  baseQueryKey: ['messaging-air-handoff'],
  getTruelarkBusinessId: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'truelark-business-id',
    locationId,
  ],
  getTenDlcRegistrationStatus: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'ten-dlc-registration-status',
    locationId,
  ],
  getBusinessSettings: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'bridgeline-business-settings',
    locationId,
  ],
  getAutoRules: (locationId: string, autoMessageType: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'auto-rules',
    locationId,
    autoMessageType,
  ],
  getSchedulingAppointmentTypes: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'scheduling-appointment-types',
    locationId,
  ],
  getSchedulingStaffs: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'scheduling-staffs',
    locationId,
  ],
  getSchedulingResources: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'scheduling-resources',
    locationId,
  ],
  getSchedulingSchedules: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'scheduling-schedules',
    locationId,
  ],
  getMessagingAiTasksReviewedCount: (locationId: string) => [
    ...MessagingAirHandoffQueryKeys.baseQueryKey,
    'messaging-ai-tasks-reviewed-count',
    locationId,
  ],
};

const MINUTE_MS = 60 * 1000;

export const getMessagingAiTasksReviewedCountQueryOptions = (locationId: string) => ({
  queryKey: MessagingAirHandoffQueryKeys.getMessagingAiTasksReviewedCount(locationId),
  queryFn: async (): Promise<CountOfTasksReviewedByLocationResponse> => {
    return await TaskService.CountOfTasksReviewedByLocation(authorizedFetch(), {
      locationId: [locationId],
      source: TaskSource.SOURCE_MESSAGING,
      creatorType: CreatorKind.CREATOR_KIND_AIR,
      timeWindow: TimeWindow.TIME_WINDOW_LAST_7_DAYS,
    });
  },
  cacheTime: 5 * MINUTE_MS,
  staleTime: 5 * MINUTE_MS,
});

export {
  getTruelarkBusinessIdQueryOptions,
  getTenDlcRegistrationStatusQueryOptions,
  getBusinessSettingsQueryOptions,
  getAutoRulesQueryOptions,
  getSchedulingAppointmentTypesQueryOptions,
  getSchedulingStaffsQueryOptions,
  getSchedulingResourcesQueryOptions,
  getSchedulingSchedulesQueryOptions,
};
